export default __webpack_public_path__ + "static/media/AnimalMagic_02.ca7402ab.png";